import React from 'react';
import { Text, TextStyle, View, ViewStyle } from 'react-native';

import { KHColors, KHIcon, KHProgressBar } from '../khui';

const styles = {
  progressIndicator: {
    height: 40,
    marginHorizontal: 24,
    marginTop: 12,
    marginBottom: 8,
  } as ViewStyle,
  steps: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  } as ViewStyle,
  progressBar: {
    top: 8,
    left: 32,
    right: 24,
    height: 8,
    position: 'absolute',
  } as ViewStyle,
  step: {
    alignItems: 'center',
    justifyContent: 'center',
  } as ViewStyle,
  stepLabel: {
    marginTop: 4,
    fontSize: 12,
    color: KHColors.text,
  } as TextStyle,
  stepLabelActive: {
    color: KHColors.textAccent,
    fontWeight: 'bold',
  } as TextStyle,
  stepCircle: {
    width: 24,
    height: 24,
    borderRadius: 24,
    backgroundColor: KHColors.progressBarTrack,
    justifyContent: 'center',
    alignItems: 'center',
  } as ViewStyle,
  stepCircleBackgroundActive: {
    backgroundColor: KHColors.progressBar,
  } as ViewStyle,
  stepCircleLabel: {
    fontSize: 12,
    color: KHColors.text,
  } as TextStyle,
  stepCircleLabelActive: {
    color: KHColors.textContrast,
  },
};

const Step = ({
  stepNumber,
  label,
  currentStepNumber,
}: {
  stepNumber: number;
  label: string;
  currentStepNumber: number;
}) => (
  <View style={styles.step}>
    <View
      style={[
        styles.stepCircle,
        currentStepNumber >= stepNumber && styles.stepCircleBackgroundActive,
      ]}
    >
      {currentStepNumber > stepNumber ? (
        <KHIcon source="check" size={16} color={KHColors.iconContrast} />
      ) : (
        <Text
          style={[
            styles.stepCircleLabel,
            currentStepNumber === stepNumber && styles.stepCircleLabelActive,
          ]}
        >
          {stepNumber}
        </Text>
      )}
    </View>
    <Text style={[styles.stepLabel, currentStepNumber === stepNumber && styles.stepLabelActive]}>
      {label}
    </Text>
  </View>
);

interface Props {
  currentStepNumber: number;
}

export default function BookingProgressIndicator({ currentStepNumber }: Props): JSX.Element {
  return (
    <View style={styles.progressIndicator}>
      <KHProgressBar progress={(currentStepNumber - 1) / 3} style={styles.progressBar} square />
      <View style={styles.steps}>
        <Step label="Schedule" currentStepNumber={currentStepNumber} stepNumber={1} />
        <Step label="Details" currentStepNumber={currentStepNumber} stepNumber={2} />
        <Step label="Review" currentStepNumber={currentStepNumber} stepNumber={3} />
        <Step label="Book" currentStepNumber={currentStepNumber} stepNumber={4} />
      </View>
    </View>
  );
}
